import { put, delay, takeLatest } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import * as api from 'data/api';
import { transformSearchSuggestions } from 'data/transformers/search-suggestion';
import { actions } from './slice';
import { buildFallbackSuggestion } from './utils';
const FETCH_SUGGESTIONS_DELAY = 350;
export function* fetchSuggestions(_ref) {
  let {
    payload,
    meta
  } = _ref;
  yield delay(FETCH_SUGGESTIONS_DELAY);
  const {
    query
  } = payload;
  const {
    title
  } = meta;
  const fallbackSuggestions = [buildFallbackSuggestion(title, query)];
  const response = yield* call(api.getSearchSuggestions, {
    query
  });

  if ('errors' in response) {
    yield put(actions.fetchSuggestionsFailure({
      fallbackSuggestions
    }));
    return;
  }

  const suggestions = [...transformSearchSuggestions(response.search_suggestions), ...fallbackSuggestions];
  yield put(actions.fetchSuggestionsSuccess({
    suggestions
  }));
}
export default function* saga() {
  yield takeLatest(actions.fetchSuggestionsRequest.type, fetchSuggestions);
}